export default __webpack_public_path__ + "static/page-pattern-3b522be96eb2142858a1422fd64ecc18.svg";